import { useState} from "react";
import { Divider, Typography } from "antd";
import { DownCircleOutlined, UpCircleOutlined } from "@ant-design/icons";
import { SingleLayerSettingsHelpContent } from "./SingleLayerSettingsHelpContent";

const { Text } = Typography;

export function SingleLayerSettingsHelp({
    data,
    colorMapName,
    openDrawer,
    isH3
}) {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const legendMaxHeight = 286;

    return (
        <div
            style={{
                position: 'fixed',
                right: openDrawer ? 540 : 40,
                bottom: 40,
                backgroundColor: '#fff',
                padding: 12,
                backgroundClip: 'padding-box',
                borderRadius: '8px',
                boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
                overflow: 'hidden',
                zIndex: 100,
                transition: 'all 0.3s ease-in-out',
            }}>
            <div
                style={{
                    maxHeight: isCollapsed ? 25 : legendMaxHeight,
                    transition: 'max-height 0.3s ease-in-out',
                    overflow: 'auto'
                }}>
                <div
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                    }}><h4 style={{
                        minWidth: 120,
                        marginBottom: 8,
                        color: 'rgba(0, 0, 0, 0.88)',
                        fontWeight: 600,
                        margin: "5px 0 0 0",
                    }}>Legend</h4>
                    {isCollapsed
                        ? <UpCircleOutlined style={{ color: '#898989' }} />
                        : <DownCircleOutlined style={{ color: '#898989' }} />}
                </div>
                <Divider style={{ margin: "15px 0" }}></Divider>
                <SingleLayerSettingsHelpContent
                    data={data}
                    colorMapName={colorMapName}
                    isH3={isH3} />

            </div>
        </div>
    )
}
